import type { PostTheme, PostThemeLineHeights, WebTheme } from '../types';

const LINE_HEIGHT_OPTIONS = {
  Less: 1.2,
  Normal: 1.5,
  More: 1.8,
};

export const postThemeToCSSVariables = (theme: PostTheme): Record<string, string> => {
  return Object.entries(theme).reduce(
    (acc, [key, value]) => {
      if (['header_custom_css'].includes(key)) {
        return acc;
      }

      const newKey = `--wt-${key.replaceAll('_', '-')}`;
      if (key === 'inline_link_italic' && (value === true || value === 'true')) {
        acc['--wt-inline-link-font-style'] = 'italic';
        return acc;
      }
      if (key === 'inline_link_bold' && (value === true || value === 'true')) {
        acc['--wt-inline-link-font-weight'] = 'bold';
        return acc;
      }
      if (key === 'inline_link_underline' && (value === true || value === 'true')) {
        acc['--wt-inline-link-underline'] = 'underline';
        return acc;
      }
      if (key.includes('line_height_size') && typeof value === 'string') {
        acc[`${newKey}-original`] =
          value.toLowerCase() === 'normal'
            ? 'normal'
            : LINE_HEIGHT_OPTIONS[value as keyof typeof PostThemeLineHeights].toString();
        acc[newKey] = LINE_HEIGHT_OPTIONS[value as keyof typeof PostThemeLineHeights].toString();
        return acc;
      }

      acc[newKey] = value;

      return acc;
    },
    {} as Record<string, string>,
  );
};

const EXCLUDED_WEB_THEME_KEYS = ['content_theme', 'name', 'owner_id', 'purpose', 'subscribe_theme'];
export const webThemeToCSSVariables = (theme: WebTheme): Record<string, string> => {
  return Object.entries(theme).reduce(
    (acc, [key, value]) => {
      if (!EXCLUDED_WEB_THEME_KEYS.includes(key)) {
        const newKey = `--site-theme-${key.replaceAll('_', '-')}`;
        acc[newKey] = value;
      }

      return acc;
    },
    {} as Record<string, string>,
  );
};
